import { createApp } from 'vue'
import { router } from '@/router';
import App from '@/App.vue'
import {BootstrapVue3, BToastPlugin} from 'bootstrap-vue-3'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import VueSelect from 'vue3-select2-component'
import VCalendar from 'v-calendar';
import SummernoteEditor from 'vue3-summernote-editor';
import PrimeVue from 'primevue/config';
import DatePicker from 'vue3-datepicker'
import VueTelInput from 'vue3-tel-input'
import Vue3TagsInput from "vue3-tags-input";
import VueTimepicker from 'vue3-timepicker'
import VueApexCharts from "vue3-apexcharts";
import VueEasyLightbox from "vue-easy-lightbox";
import VueSweetalert2 from 'vue-sweetalert2' 
import AOS from 'aos'



// Frontend Layouts Components
import LayoutHeader from '@/views/frontend/layouts/layout-header.vue'
import HeaderMenu from '@/views/frontend/layouts/header-menu.vue'
import CursorIndex from '@/views/frontend/layouts/cursor-index.vue'
import Pages_Footer from '@/views/frontend/layouts/pages-footer.vue'
import Provider_Sidebar from '@/views/frontend/layouts/provider-sidebar.vue'
import Provider_Header from '@/views/frontend/layouts/provider-header.vue'
import Customer_Sidebar from '@/views/frontend/layouts/customer-sidebar.vue'
import HomeFooter from '@/views/frontend/layouts/home-footer.vue';
import LayoutFooter from '@/views/frontend/layouts/layout-footer.vue';
import HeaderTop from '@/views/frontend/layouts/headertop.vue'

// Frontend Pages Components

// Home One

import HomeBanner from '@/views/frontend/pages/home/home-1/home-banner.vue'
import HomeServices from '@/views/frontend/pages/home/home-1/home-services.vue'
import HomePopular from '@/views/frontend/pages/home/home-1/home-popular.vue'
import ComputerService from '@/views/frontend/pages/home/home-1/computer-service.vue';
import RemovalsCarousel from '@/views/frontend/pages/home/home-1/removals-carousel.vue';
import ManVan from '@/views/frontend/pages/home/home-1/man-van.vue';
import FurnitureAssembly from '@/views/frontend/pages/home/home-1/furniture-assembly.vue';
import ElectricalCarousel from '@/views/frontend/pages/home/home-1/electrical-carousel.vue';
import ConstructionCarousel from '@/views/frontend/pages/home/home-1/construction-carousel.vue';
import PlumbingCarousel from '@/views/frontend/pages/home/home-1/plumbing-carousel.vue';
import MoreService from '@/views/frontend/pages/home/home-1/more-service.vue';
import HomeWork from '@/views/frontend/pages/home/home-1/home-work.vue'
import HomeProvider from '@/views/frontend/pages/home/home-1/home-provider.vue';
import HomeTestimonial from '@/views/frontend/pages/home/home-1/home-testimonial.vue';
import HomeBlog from '@/views/frontend/pages/home/home-1/home-blog.vue';
import LinkSection from '@/views/frontend/pages/home/home-1/link-section.vue';

// Home Two

import Indexprofessional from '@/views/frontend/pages/home/home-2/index-professional.vue';
import Indexfeatureservice from '@/views/frontend/pages/home/home-2/index-feature-service.vue';
import Indexoffering from '@/views/frontend/pages/home/home-2/index-offering.vue';
import Indexplaning from '@/views/frontend/pages/home/home-2/index-planing.vue';
import Indexblog from '@/views/frontend/pages/home/home-2/index-blog.vue';

// Home Three

import IndexThreeHero from '@/views/frontend/pages/home/home-3/index-three-hero.vue'
import IndexThreeFeaturedService from '@/views/frontend/pages/home/home-3/index-three-featuredservice.vue'
import IndexThreePopular from '@/views/frontend/pages/home/home-3/index-three-popular.vue'
import IndexThreePricing from '@/views/frontend/pages/home/home-3/index-three-pricing.vue'
import IndexThreeClient from '@/views/frontend/pages/home/home-3/index-three-client.vue'
import IndexThreePartners from '@/views/frontend/pages/home/home-3/index-three-partners.vue'
import IndexThreeFooter from '@/views/frontend/pages/home/home-3/footer'

// Home Four

import IndexFourBanner from '@/views/frontend/pages/home/home-4/index-four-banner.vue'
import IndexFourAppointment from '@/views/frontend/pages/home/home-4/index-four-appointment.vue'
import IndexFourService from '@/views/frontend/pages/home/home-4/index-four-service.vue'
import IndexFourWork from '@/views/frontend/pages/home/home-4/index-four-work.vue'
import IndexFourLatest from '@/views/frontend/pages/home/home-4/index-four-latest.vue'
import IndexFourFooter from '@/views/frontend/pages/home/home-4/footer.vue'

// Home Five

import IndexFiveBanner from '@/views/frontend/pages/home/home-5/index-five-banner.vue'
import IndexFiveCatering from '@/views/frontend/pages/home/home-5/index-five-catering.vue'
import IndexFiveCategories from '@/views/frontend/pages/home/home-5/index-five-categories.vue'
import IndexFiveWork from '@/views/frontend/pages/home/home-5/index-five-work.vue'
import IndexFiveServices from '@/views/frontend/pages/home/home-5/index-five-services.vue'
import IndexFiveBranch from '@/views/frontend/pages/home/home-5/index-five-branch.vue'
import IndexFiveBlog from '@/views/frontend/pages/home/home-5/index-five-blog.vue'
import IndexFiveFooter from '@/views/frontend/pages/home/home-5/footer.vue'

// Home Six

import IndexSixBanner from '@/views/frontend/pages/home/home-6/index-six-banner.vue'
import IndexSixCompany from '@/views/frontend/pages/home/home-6/index-six-company.vue'
import IndexSixWork from '@/views/frontend/pages/home/home-6/index-six-work.vue'
import IndexSixTeam from '@/views/frontend/pages/home/home-6/index-six-team.vue'
import IndexSixPricing from '@/views/frontend/pages/home/home-6/index-six-pricing.vue'
import IndexSixFooter from '@/views/frontend/pages/home/home-6/footer.vue'

// Home Seven

import IndexSevenHeadertop from '@/views/frontend/pages/home/home-7/index-seven-headertop.vue';
import IndexSevenBanner from '@/views/frontend/pages/home/home-7/index-seven-banner.vue'
import IndexSevenService from '@/views/frontend/pages/home/home-7/index-seven-service.vue'
import IndexSevenMechanics from '@/views/frontend/pages/home/home-7/index-seven-mechanics.vue'
import IndexSevenCustomer from '@/views/frontend/pages/home/home-7/index-seven-customer.vue'
import IndexSevenAdditional from '@/views/frontend/pages/home/home-7/index-seven-additional.vue'
import IndexSevenBlog from '@/views/frontend/pages/home/home-7/index-seven-blog.vue'
import IndexSevenPartner from '@/views/frontend/pages/home/home-7/index-seven-partner.vue'
import IndexSevenFooter from '@/views/frontend/pages/home/home-7/footer.vue'

// Home Eight

import IndexEightBanner from '@/views/frontend/pages/home/home-8/index-eight-banner.vue'
import IndexEightPopular from '@/views/frontend/pages/home/home-8/index-eight-popular.vue'
import IndexEightMeet from '@/views/frontend/pages/home/home-8/index-eight-meet.vue'
import IndexEightCustomer from '@/views/frontend/pages/home/home-8/index-eight-customer.vue'
import IndexEightBlog from '@/views/frontend/pages/home/home-8/index-eight-blog.vue'
import IndexEightFooter from '@/views/frontend/pages/home/home-8/footer.vue'

// Home Nine

import IndexNineBanner from '@/views/frontend/pages/home/home-9/index-nine-banner.vue'
import IndexNineFeatured from '@/views/frontend/pages/home/home-9/index-nine-featured.vue'
import IndexNineCategories from '@/views/frontend/pages/home/home-9/index-nine-categories.vue'
import IndexNineTestimonial from '@/views/frontend/pages/home/home-9/index-nine-pricing.vue'
import IndexNinePartner from '@/views/frontend/pages/home/home-9/index-nine-partner.vue'
import IndexNineService from '@/views/frontend/pages/home/home-9/index-nine-service.vue'
import IndexNineApp from '@/views/frontend/pages/home/home-9/index-nine-app.vue'
import IndexNineFooter from '@/views/frontend/pages/home/home-9/footer.vue'

// Home ten

import IndexTenBanner from '@/views/frontend/pages/home/home-10/index-ten-banner.vue'
import IndexTenPopular from '@/views/frontend/pages/home/home-10/index-ten-popular.vue'
import IndexTenService from '@/views/frontend/pages/home/home-10/index-ten-service.vue'
import IndexTenProvider from '@/views/frontend/pages/home/home-10/index-ten-provider.vue'
import IndexTenTestimonial from '@/views/frontend/pages/home/home-10/index-ten-testimonial.vue'
import IndexTenPricing from '@/views/frontend/pages/home/home-10/index-ten-pricing.vue'
import IndexTenPartner from '@/views/frontend/pages/home/home-10/index-ten-partner.vue'
import IndexTenFooter from '@/views/frontend/pages/home/home-10/footer.vue'

import Page_Breadcrumb from '@/components/breadcrumb/page-breadcrumb.vue'
import Services_Breadcrumb from '@/components/breadcrumb/services-breadcrumb.vue'
import Breadcrumb_Index from '@/components/breadcrumb/breadcrumb-index.vue'

// pages

import Booking_Header from '@/views/frontend/pages/pages/booking/booking-header.vue'

import About from '@/views/frontend/pages/pages/aboutUs/about.vue'
import AboutProvider from '@/views/frontend/pages/pages/aboutUs/about-provider.vue'
import AboutClient from '@/views/frontend/pages/pages/aboutUs/aboutclient.vue'
import ContactContent from '@/views/frontend/pages/pages/contactUs/contactcontent.vue'
import ContactMap from '@/views/frontend/pages/pages/contactUs/contactmap.vue'
import BookingContent from '@/views/frontend/pages/pages/booking/booking/bookingcontent.vue'
import CategoriesContent from '@/views/frontend/pages/pages/categories/categoriescontent.vue'
import ComingSoonContent from '@/views/frontend/pages/pages/comingsoon/comingsooncontent.vue'
import FaqContent from '@/views/frontend/pages/pages/faq/faqcontent.vue'
import HowItsWorkContent from '@/views/frontend/pages/pages/howitswork/howitsworkcontent.vue'
import PricingContent from '@/views/frontend/pages/pages/pricingplan/pricingcontent.vue'
import PrivacyPolicyContent from '@/views/frontend/pages/pages/privacypolicy/privacypolicycontent.vue'
import Provider_Location from '@/views/frontend/pages/providers/dashboard/provider-location.vue'
import Services_Sidebar from '@/views/frontend/pages/services/services-sidebar.vue'
import Provider_Expertise from '@/views/frontend/pages/services/providers/provider-details/provider-expertise.vue'
import Our_Services from '@/views/frontend/pages/services/providers/provider-details/our-services.vue'
import Our_Branches from '@/views/frontend/pages/services/providers/provider-details/our-branches.vue'
import Our_Gallery from '@/views/frontend/pages/services/providers/provider-details/our-gallery.vue'
import Services_Slider from '@/views/frontend/pages/services/services-details/services-slider.vue'
import Services_Gallery from '@/views/frontend/pages/services/services-details/services-gallery.vue'
import Details_Slider from '@/views/frontend/pages/services/services-details2/details-slider.vue'


// Admin Components

import Adminabusereport from '@/components/admin/pageheader.vue'
import AdminServiceInformation from '@/views/admin/pages/Services/Addservice/service-information.vue'
import AdminServiceAvailability from '@/views/admin/pages/Services/Addservice/availability.vue'
import AdminServiceLocation from '@/views/admin/pages/Services/Addservice/location.vue'
import AdminServiceGallery from '@/views/admin/pages/Services/Addservice/gallery.vue'
import AdminServiceTimepicker from '@/views/admin/pages/Services/Addservice/timepicker.vue'
import AdminServiceSeo from '@/views/admin/pages/Services/Addservice/seo.vue'

//admin 
import Adminheader from '@/views/admin/layouts/header.vue'
import Adminsidebar from '@/views/admin/layouts/sidebar.vue'
import SideLinkHeading from '@/views/admin/layouts/sidelinkheading.vue'
import ServicesTab from '@/views/admin/layouts/servicestab'
import Active_Blog from '@/views/admin/pages/Content/Blog/active-blog.vue'
import Inactive_Bloglist from '@/views/admin/pages/Content/Blog/inactive-bloglist.vue'
import Pending_Bloglist from '@/views/admin/pages/Content/Blog/pending-bloglist.vue'
import Chat_Profile from '@/views/admin/pages/Others/chat-profile.vue'
import Chatcontent from '@/views/admin/pages/Others/chatcontent.vue'
import Chatuser_list from '@/views/admin/pages/Others/chatuser-list.vue'

/*********************** Admin Model  *******************/
import Announcement_Model from '@/components/model/admin-model/announcement-model'
import Abusemodel from '@/components/model/admin-model/abusemodel.vue'
import Sms_Template_Model from '@/components/model/admin-model/sms-template-model.vue'
import Email_Template_Model from '@/components/model/admin-model/email-template-model.vue'
import Email_Newsletter_Model from '@/components/model/admin-model/email-newsletter-model.vue'
import Featured_Service_Model from '@/components/model/admin-model/featured-service-model.vue'
import Service_Offers_Model from '@/components/model/admin-model/service-offers-model.vue'
import Marketing_Coupons_Model from '@/components/model/admin-model/marketing-coupons-model.vue'
import Roles_Model from '@/components/model/admin-model/roles-model.vue'
import Customers_Model from '@/components/model/admin-model/customers-model.vue'
import Provider_Model from '@/components/model/admin-model/provider-model.vue'
import Faq_Model from '@/components/model/admin-model/faq-model.vue'
import Testimonials_Model from '@/components/model/admin-model/testimonials-model.vue'
import Conutries_Model from '@/components/model/admin-model/conutries-model.vue'
import States_Model from '@/components/model/admin-model/states-model.vue'
import Cities_Model from '@/components/model/admin-model/cities-model.vue'
import Users_Model from '@/components/model/admin-model/users-model.vue'
import Pages_Model from '@/components/model/admin-model/pages-model.vue'
import Payout_Request_Model from '@/components/model/admin-model/payout-request-model.vue'
import Sub_Categories_Model from '@/components/model/admin-model/sub-categories-model.vue'
import Categories_Model from '@/components/model/admin-model/categories-model.vue'
import Review_Type_Model from '@/components/model/admin-model/review-type-model.vue'
import Report_Delete_Model from '@/components/model/admin-model/report-delete-model.vue'
import Delete_Model from '@/components/model/admin-model/delete-model.vue'
import Taxrate_model from '@/components/model/admin-model/taxratemodel.vue'
import Security_Model from '@/components/model/admin-model/security-model.vue'
import Blog_Categories_Model from '@/components/model/admin-model/blog-categories-model.vue'
import Database_Backup_Model from '@/components/model/admin-model/database-backup-model.vue'
import System_Model from '@/components/model/admin-model/system-model.vue'
import Banip_Model from '@/components/model/admin-model/banip-model.vue'
import Storage_Model from '@/components/model/admin-model/storage-model.vue'
import Currencies_Model from '@/components/model/admin-model/currencies-model.vue'
import Payment_Model from '@/components/model/admin-model/payment-model.vue'
import Gateways_Model from '@/components/model/admin-model/gateways-model.vue'
import Sms_Model from '@/components/model/admin-model/sms-model.vue'
import Email_Model from '@/components/model/admin-model/email-model.vue'
import Social_Model from '@/components/model/admin-model/social-model.vue'
import Contact_Message_Model from '@/components/model/admin-model/contact-message-model.vue'
import Offers_Model from '@/components/model/admin-model/offers-model.vue'



//Frontend Modal

import Provider_Dashboard_Modal from '@/components/model/provider-dashboard-modal.vue'
import Provider_Services_Modal from '@/components/model/provider-services-modal.vue'
import Provider_Booking_Modal from '@/components/model/provider-booking-modal.vue'
import Staff_Modal from '@/components/model/staff-modal.vue'
import Staff_Grid_Modal from '@/components/model/staff-grid-modal.vue'
import Staff_Details_Modal from '@/components/model/staff-details-modal.vue'
import Customer_List_Modal from '@/components/model/customer-list-modal.vue'
import Customer_Grid_Modal from '@/components/model/customer-grid-modal.vue'
import Provider_Payout_Modal from '@/components/model/provider-payout-modal.vue'
import Provider_Holiday_Modal from '@/components/model/provider-holiday-modal.vue'
import Provider_Coupons_Modal from '@/components/model/provider-coupons-modal.vue'
import Provider_Offers_Modal from '@/components/model/provider-offers-modal.vue'
import Provider_Earning_Modal from '@/components/model/provider-earning-modal.vue'
import Provider_Security_Settings_Modal from '@/components/model/provider-security-settings-modal.vue'
import Provider_Plan_Modal from '@/components/model/provider-plan-modal.vue'
import Payment_Settings_Modal from '@/components/model/payment-settings-modal.vue'
import Provider_Verification_Modal from '@/components/model/provider-verification-modal.vue'
import Security_Settings_Modal from '@/components/model//security-settings-modal.vue'
import IndexTwoModal from '@/components/model/index-two-modal.vue';
import IndexModal from '@/components/model/index-modal.vue';
import Create_Services_Modal from '@/components/model/create-services-modal.vue'
import User_Booking_Modal from '@/components/model/user-booking-modal.vue'
import Service_Details_Modal from '@/components/model/service-details-modal.vue'



// plugins
import 'aos/dist/aos.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@/assets/plugins/summernote/summernote-lite.min.css';
import '@/assets/plugins/summernote/summernote-lite.min.js';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue3-timepicker/dist/VueTimepicker.css';
import '@/assets/css/tabler-icons.css';
import '@/assets/css/feather.css';
import '@/assets/css/feather.min.js';
import "v-calendar/dist/style.css";


import swal from 'sweetalert2';

window.Swal = swal;

if(window.location.href.includes("/admin")) {
    require('@/assets/css/admin.css');
  }
  else {
    require('vue3-tel-input/dist/vue3-tel-input.css');
    require('@/assets/scss/main.scss');
}



const app = createApp(App)



// *************** Frontend Layouts Components ***************

app.component('layout-header', LayoutHeader)
app.component('header-menu', HeaderMenu)
app.component('cursor-index', CursorIndex )
app.component('pages-footer', Pages_Footer )
app.component('provider-sidebar', Provider_Sidebar )
app.component('provider-header', Provider_Header )
app.component('customer-sidebar', Customer_Sidebar )
app.component('home-footer', HomeFooter)
app.component('layout-footer', LayoutFooter)
app.component('header-top',HeaderTop)

// *************** Frontend Pages Components ***************

// Home one
app.component('home-banner', HomeBanner)
app.component('home-services', HomeServices)
app.component('home-popular', HomePopular)
app.component('computer-service', ComputerService)
app.component('removals-carousel', RemovalsCarousel)
app.component('man-van', ManVan)
app.component('furniture-assembly', FurnitureAssembly)
app.component('electrical-carousel', ElectricalCarousel)
app.component('construction-carousel', ConstructionCarousel)
app.component('plumbing-carousel', PlumbingCarousel)
app.component('more-service', MoreService)
app.component('home-work', HomeWork)
app.component('home-provider', HomeProvider)
app.component('home-testimonial', HomeTestimonial)
app.component('home-blog', HomeBlog)
app.component('link-section', LinkSection)

// Home Two
app.component('index-professional', Indexprofessional)
app.component('index-featureservice', Indexfeatureservice)
app.component('index-offering', Indexoffering)
app.component('index-planing', Indexplaning)
app.component('index-blog', Indexblog)

// Home Three

app.component('index-three-hero', IndexThreeHero)
app.component('index-three-featuredservice', IndexThreeFeaturedService)
app.component('index-three-popular', IndexThreePopular)
app.component('index-three-pricing', IndexThreePricing)
app.component('index-three-client', IndexThreeClient)
app.component('index-three-partners', IndexThreePartners)
app.component('index-three-footer', IndexThreeFooter)

// Home Four

app.component('index-four-banner',IndexFourBanner)
app.component('index-four-appointment',IndexFourAppointment)
app.component('index-four-service',IndexFourService)
app.component('index-four-work',IndexFourWork)
app.component('index-four-latest',IndexFourLatest)
app.component('index-four-footer',IndexFourFooter)

// Home Five

app.component('index-five-banner',IndexFiveBanner)
app.component('index-five-catering',IndexFiveCatering)
app.component('index-five-categories',IndexFiveCategories)
app.component('index-five-work',IndexFiveWork)
app.component('index-five-services',IndexFiveServices)
app.component('index-five-branch',IndexFiveBranch)
app.component('index-five-blog',IndexFiveBlog)
app.component('index-five-footer',IndexFiveFooter)

// Home Six

app.component('index-six-banner',IndexSixBanner)
app.component('index-six-company',IndexSixCompany)
app.component('index-six-work',IndexSixWork)
app.component('index-six-team',IndexSixTeam)
app.component('index-six-pricing',IndexSixPricing)
app.component('index-six-footer',IndexSixFooter)

// Home Seven

app.component('index-seven-headertop',IndexSevenHeadertop)
app.component('index-seven-banner',IndexSevenBanner)
app.component('index-seven-service',IndexSevenService)
app.component('index-seven-mechanics',IndexSevenMechanics)
app.component('index-seven-customer',IndexSevenCustomer)
app.component('index-seven-additional',IndexSevenAdditional)
app.component('index-seven-blog',IndexSevenBlog)
app.component('index-seven-partner',IndexSevenPartner)
app.component('index-seven-footer',IndexSevenFooter)

// Home Eight

app.component('index-eight-banner',IndexEightBanner)
app.component('index-eight-popular',IndexEightPopular)
app.component('index-eight-meet',IndexEightMeet)
app.component('index-eight-customer',IndexEightCustomer)
app.component('index-eight-blog',IndexEightBlog)
app.component('index-eight-footer',IndexEightFooter)

// Home Nine

app.component('index-nine-banner',IndexNineBanner)
app.component('index-nine-featured',IndexNineFeatured)
app.component('index-nine-categories',IndexNineCategories)
app.component('index-nine-testimonial',IndexNineTestimonial)
app.component('index-nine-partner',IndexNinePartner)
app.component('index-nine-service',IndexNineService)
app.component('index-nine-app',IndexNineApp)
app.component('index-nine-footer',IndexNineFooter)

// Home ten

app.component('index-ten-banner',IndexTenBanner)
app.component('index-ten-popular',IndexTenPopular)
app.component('index-ten-service',IndexTenService)
app.component('index-ten-provider',IndexTenProvider)
app.component('index-ten-testimonial',IndexTenTestimonial)
app.component('index-ten-pricing',IndexTenPricing)
app.component('index-ten-partner',IndexTenPartner)
app.component('index-ten-footer',IndexTenFooter)


// *************** Frontend Components ***************

app.component('page-breadcrumb', Page_Breadcrumb)
app.component('services-breadcrumb', Services_Breadcrumb)
app.component('breadcrumb-index', Breadcrumb_Index)


app.component('booking-header',Booking_Header)

app.component('about-provider',AboutProvider)
app.component('aboutclient',AboutClient)
app.component('about-us',About)
app.component('contactcontent',ContactContent)
app.component('contactmap',ContactMap)
app.component('bookingcontent',BookingContent)
app.component('categoriescontent',CategoriesContent)
app.component('comingsooncontent',ComingSoonContent)
app.component('faqcontent',FaqContent)
app.component('howitsworkcontent',HowItsWorkContent)
app.component('pricingcontent',PricingContent)
app.component('privacypolicycontent',PrivacyPolicyContent)
app.component('provider-location',Provider_Location)
app.component('services-sidebar',Services_Sidebar)
app.component('provider-expertise',Provider_Expertise)
app.component('our-services',Our_Services)
app.component('our-branches',Our_Branches)
app.component('our-gallery',Our_Gallery)
app.component('services-slider',Services_Slider)
app.component('services-gallery',Services_Gallery)
app.component('details-slider',Details_Slider)


// *************** Admin layout Components ***************
app.component('layout', Adminheader)
app.component('adminsidebar', Adminsidebar)
app.component('sidelinkheading',SideLinkHeading)
app.component('servicestab', ServicesTab)

//admin component
app.component('abusereport', Adminabusereport)
app.component('admin-service-information', AdminServiceInformation)
app.component('admin-service-availability', AdminServiceAvailability)
app.component('admin-service-location', AdminServiceLocation)
app.component('admin-service-gallery', AdminServiceGallery)
app.component('admin-service-timepicker', AdminServiceTimepicker)
app.component('admin-service-seo', AdminServiceSeo)
app.component('active-blog',Active_Blog)
app.component('inactive-bloglist',Inactive_Bloglist)
app.component('pending-bloglist',Pending_Bloglist)
app.component('chat-profile',Chat_Profile)
app.component('chatuser-list',Chatuser_list)
app.component('chatcontent',Chatcontent)

/****************** Admin Model  ****************/
app.component('announcement-model',Announcement_Model)
app.component('abuse-model',Abusemodel)
app.component('sms-template-model',Sms_Template_Model)
app.component('email-template-model',Email_Template_Model)
app.component('email-newsletter-model',Email_Newsletter_Model)
app.component('featured-service-model',Featured_Service_Model)
app.component('service-offers-model',Service_Offers_Model)
app.component('roles-model',Roles_Model)
app.component('customers-model',Customers_Model)
app.component('provider-model',Provider_Model)
app.component('faq-model',Faq_Model)
app.component('testimonials-model',Testimonials_Model)
app.component('conutries-model',Conutries_Model)
app.component('states-model',States_Model)
app.component('cities-model',Cities_Model)
app.component('users-model',Users_Model)
app.component('pages-model',Pages_Model)
app.component('payout-request-model',Payout_Request_Model)
app.component('sub-categories-model',Sub_Categories_Model)
app.component('categories-model',Categories_Model)
app.component('review-type-model',Review_Type_Model)
app.component('report-delete-model',Report_Delete_Model)
app.component('delete-model',Delete_Model)
app.component('taxratemodel',Taxrate_model)
app.component('security-model',Security_Model)
app.component('blog-categories-model',Blog_Categories_Model)
app.component('marketing-coupons-model',Marketing_Coupons_Model)
app.component('database-backup-model',Database_Backup_Model)
app.component('system-model',System_Model)
app.component('banip-model',Banip_Model)
app.component('storage-model',Storage_Model)
app.component('currencies-model',Currencies_Model)
app.component('payment-model',Payment_Model)
app.component('gateways-model',Gateways_Model)
app.component('sms-model',Sms_Model)
app.component('email-model',Email_Model)
app.component('social-model',Social_Model)
app.component('contact-message-model',Contact_Message_Model)
app.component('offers-model',Offers_Model)

app.component('provider-dashboard-modal',Provider_Dashboard_Modal)
app.component('provider-services-modal',Provider_Services_Modal)
app.component('provider-booking-modal',Provider_Booking_Modal)
app.component('staff-modal',Staff_Modal)
app.component('staff-grid-modal',Staff_Grid_Modal)
app.component('staff-details-modal',Staff_Details_Modal)
app.component('customer-list-modal',Customer_List_Modal)
app.component('customer-grid-modal',Customer_Grid_Modal)
app.component('provider-payout-modal',Provider_Payout_Modal)
app.component('provider-holiday-modal',Provider_Holiday_Modal)
app.component('provider-coupons-modal',Provider_Coupons_Modal)
app.component('provider-offers-modal',Provider_Offers_Modal)
app.component('provider-eraning-modal',Provider_Earning_Modal)
app.component('provider-security-settings-modal',Provider_Security_Settings_Modal)
app.component('provider-plan-modal',Provider_Plan_Modal)
app.component('payment-settings-modal',Payment_Settings_Modal)
app.component('provider-verification-modal',Provider_Verification_Modal)
app.component('security-settings-modal',Security_Settings_Modal)
app.component('index-two-modal', IndexTwoModal)
app.component('index-modal', IndexModal)
app.component('create-services-modal',Create_Services_Modal)
app.component('user-booking-modal',User_Booking_Modal)
app.component('service-details-modal',Service_Details_Modal)


app.component('SummernoteEditor', SummernoteEditor);
app.component('vue-select', VueSelect)
app.component('date-picker', DatePicker)
app.component('vue3-tags-input', Vue3TagsInput);
app.component('timepicker',VueTimepicker)
.use(VueTelInput)
.use(BootstrapVue3)
.use(BToastPlugin)
.use(Antd)
.use(AOS.init())
app.use(VueSweetalert2)
app.use(VCalendar, {})
app.use(PrimeVue);
app.use(VueApexCharts);
app.use(VueEasyLightbox);
app.use(router).mount('#app');
